import React from "react";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./src/styles/theme";
import "./src/styles/reset.css";
import GlobalStyles from "./src/styles/GlobalStyles";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    {element}
  </ThemeProvider>
);
